var _rect, _line, _line2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalGateways({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 2,
    stroke: "#0A8BC7",
    strokeWidth: 1.75,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 10,
    x2: 21,
    y2: 10,
    stroke: "#0A8BC7",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 16,
    x2: 21,
    y2: 16,
    stroke: "#0A8BC7",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 7,
    r: 1.25,
    fill: "#0A8BC7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 1.25,
    fill: "#0A8BC7",
    opacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 13,
    r: 1.25,
    fill: "#0A8BC7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 13,
    r: 1.25,
    fill: "#0A8BC7",
    opacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 19,
    r: 1.25,
    fill: "#0A8BC7",
    opacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 19,
    r: 1.25,
    fill: "#0A8BC7",
    opacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5.5,
    width: 3,
    height: 3,
    rx: 0.5,
    stroke: "#0A8BC7",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11.5,
    width: 3,
    height: 3,
    rx: 0.5,
    stroke: "#0A8BC7",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17.5,
    width: 3,
    height: 3,
    rx: 0.5,
    stroke: "#0A8BC7",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalGateways);
export default __webpack_public_path__ + "static/media/total_gateways.f65603ec19cea17cce170d45631bb7f2.svg";
export { ForwardRef as ReactComponent };